import Axios from 'axios';
const ServiceURL = process.env.VUE_APP_SERVICEURL

export default {
    name: 'status',
    state: {
        allBOD: [],
    },
    getters: {
        getAllBOD: state => {
            return state.allBOD
        },
    },
    mutations: {
        GET_ALL_BOD: (state, payload) => {
            state.allBOD = payload
        },
    },
    actions: {
        async FETCH_ALL_BOD(store) {
            return await Axios({
                method: "get",
                url: ServiceURL + "bod/",
                auth: {
                    username: store.rootState.user.auth.username,
                    password: store.rootState.user.auth.password
                },
                headers: {
                    "X-API-KEY": store.rootState.user.auth.apikey
                }
            }).then(response => {
                store.commit('GET_ALL_BOD', response.data.bod)
            })
                .catch(err => {
                    return err
                });
        },
    }
}